import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import { updateUser } from "../actions";
import { updateCompanyEmail } from "../../company/actions";

import Layout from "../../shared/components/layouts/MainLayout";
import TimedBanner from '../../shared/components/notices/TimedBanner';

import UserForm from "../components/UserForm";
import EmailForm from "../components/EmailForm";

import { renderModal, closeModal } from '../../shared/components/layouts/OldModal';
import Confirmation from "../../shared/components/notices/Confirmation";
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../shared/constants/SegmentEvents';

// TODO: Cleanup
class UserProfile extends Component {
  constructor(props) {
    super(props)
    const {
      first_name,
      last_name,
      email,
      new_email_temp,
    } = this.props.user;

    this.state = {
      user_data: Object.assign({}, {
        first_name,
        last_name,
      }),
      email_data: Object.assign({}, {
        email,
      }),
      new_email_temp,
      email_form_error: null,
      alertMessage: "",
    }

    this.onEmailFormSubmit = this.onEmailFormSubmit.bind(this)
    this.onEmailChangeConfirm = this.onEmailChangeConfirm.bind(this)
    this.banner = React.createRef();
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(PageViewName.USER_PROFILE_VIEWED);
  }


  onUserFormChange = (e) => {
    const input = e.target;
    const name = input.name;
    const value = input.value;
    const data = Object.assign({}, this.state.user_data, { [name]:value } );
    this.setState({user_data: data});
  }

  onFocusUserFirstName= () => {
    segmentEventTracker.trackEvent(TrackEventName.FIRST_NAME_FOCUSED);
  }

  onFocusUserLastName= () => {
    segmentEventTracker.trackEvent(TrackEventName.LAST_NAME_FOCUSED);
  }

  onFocusUserEmailAddress= () => {
    segmentEventTracker.trackEvent(TrackEventName.EMAIL_ADDRESS_FOCUSED);
  }

  onUserFormSubmit = () => {
    segmentEventTracker.trackEvent(TrackEventName.SAVE_CHANGES_NAME_CLICKED);
    this.props.updateUser(this.state.user_data,
      response => {
        const alertMessage = !!response.data.success ?
          'Your account has been updated successfully!' : 'Your account failed to update!';
        this.setState({ alertMessage: alertMessage }, () =>{
          this.banner.current.show();
        });
      }
    );
  }

  onEmailFormChange = (e) => {
    const input = e.target;
    const name = input.name;
    const value = input.value;
    const data = Object.assign({}, this.state.email_data, { [name]:value } );
    this.setState({email_data: data});
  }

  onEmailFormSubmit = () => {
    segmentEventTracker.trackEvent(TrackEventName.SAVE_CHANGES_EMAIL_ADDRESS_CLICKED);
    renderModal(
      <Confirmation onConfirm={this.onEmailChangeConfirm}>
        <p>Do you wish to change your email?</p><br/>
        <p>{this.props.user.email} (old)</p>
        <p>{this.state.email_data['email']} (new)</p>
      </Confirmation>
    )
  }

  onEmailChangeConfirm = () => {
    this.props.updateCompanyEmail(this.state.email_data,
      response => {
        if(response.data.success) {
          this.setState({
            new_email_temp: response.data['email'],
            email_data: {email: this.props.user.email},
            email_form_error: null,
          })


          this.setState({ alertMessage: `Check your email to confirm change to ${response.data['email']}` }, () =>{
            this.banner.current.show();
          });
        } else {
          let errorMessage = 'Something went wrong'

          if(response.data.error === 'invalid_format') {
            errorMessage = 'The email you input has an invalid format'
          } else if (response.data.error === 'invalid_uniqueness') {
            errorMessage = 'The email you input already exist'
          }
          this.setState({
            email_form_error: errorMessage,
          })

          this.setState({ alertMessage: 'Email update failed' }, () =>{
            this.banner.current.show();
          });
        }
      }
    );
    closeModal();
  }

  render() {
    let {
      first_name,
      last_name,
    } = this.state.user_data;

    let {
      email
    } = this.state.email_data;

    return (
      <Fragment>
        <TimedBanner body={this.state.alertMessage} className="-success" ref={this.banner} duration={8}/>
        <Layout
          header='My account'
          gridClassName='--narrow'
        >
          <UserForm
            first_name={first_name}
            last_name={last_name}
            onChange={this.onUserFormChange}
            onSubmit={this.onUserFormSubmit}
            onFocusFirstName={this.onFocusUserFirstName}
            onFocusLastName={this.onFocusUserLastName}
          />
          <EmailForm
            email={email}
            emailFormError={this.state.email_form_error}
            onChange={this.onEmailFormChange}
            onSubmit={this.onEmailFormSubmit}
            disabled={this.props.user.email === this.state.email_data['email']}
            onFocusEmailAddress={this.onFocusUserEmailAddress}
          />
        </Layout>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return  {
    company_info: state.company,
    user: state.user,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return  {
    updateUser: (body, callback) => dispatch(updateUser(body, callback)),
    updateCompanyEmail: (body, callback) => dispatch(updateCompanyEmail(body, callback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/features/user/containers/UserProfile.js